module.exports = __webpack_public_path__ + "static/media/rga_bratislava.4b817839.jpg";